import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { BehaviorSubject } from 'rxjs'
import { IBeatmakerData } from '../../types/common.type'
import { EnvironmentService } from '../environment.service'
import { UtilsService } from '../utils.service'

interface IState {
  key: string
  value: string
}

@Injectable({
  providedIn: 'root'
})
export class AppService {
  beatMakerDataSubject: BehaviorSubject<IBeatmakerData> = new BehaviorSubject(null)
  state: IState[] = []
  getNameUrl = '/web/v1/producers/get-id-by-url'
  currentUserEmail: string

  // TODO: Move WIDGET_iD_QUERY_PARAM to a saparate place after release of widget app
  WIDGET_ID_QUERY_PARAM = 'widgetId'

  options = {
    withCredentials: true
  }

  constructor(
    private http: HttpClient,
    private utilService: UtilsService,
    private environmentService: EnvironmentService,
    private router: Router
  ) {
    this.concatenationRouteWithQueryParams()
    this.init()
  }

  concatenationRouteWithQueryParams() {
    // The logic necessary so that when changing a route, the parameter is not lost
    // but concatenated with the route address.
    // Result: https://propage.dev.testbtv.ru:4003/tracks?devBeatmakerId=119618
    this.router.events.subscribe(path => {
      if (path instanceof NavigationEnd) {
        const url: string = this.utilService.addQueryParams(path.url, this.state)
        history.replaceState(null, null, url)
      }
    })
  }

  init() {
    const widgetId = this.utilService.getParameterByName(this.WIDGET_ID_QUERY_PARAM)
    if (!!widgetId && !this.state.some(param => param.key === this.WIDGET_ID_QUERY_PARAM)) {
      this.state.push({ key: this.WIDGET_ID_QUERY_PARAM, value: widgetId })
    }

    // TODO: Move 'devBeatmakerId' to constants after release of widget app
    const devBeatmakerId = this.utilService.getParameterByName('devBeatmakerId')
    if (!!devBeatmakerId && !this.state.some(param => param.key === 'devBeatmakerId')) {
      this.state.push({ key: 'devBeatmakerId', value: devBeatmakerId })
    }

    const url = this.environmentService.getSettingsUrl() + this.getNameUrl
    const queryParams = document.location.search
    const resultUrl = `${url}${queryParams}`

    this.http.get<IBeatmakerData>(resultUrl, this.options).subscribe(res => {
      this.currentUserEmail = res.currentUserEmail
      this.beatMakerDataSubject.next(res)
    })
  }
}
